// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8b68c361","488":"2b5acb16"}[chunkId] + ".chunk.js";
};